import AccountModel from '@/models/services/account/AccountModel';
import appStore     from '@/stores/appStore';
import useDidMount  from '@widesk-core/hooks/useDidMount';
import { reaction } from 'mobx';
import { useState } from 'react';

const useAccount = () => {
	const [account, setAccount] = useState<AccountModel | null>(appStore.account);
	const [isSelectingAccount, setIsSelectingAccount] = useState(appStore.isSelectingAccount);

	const selectAccount = async (id: id | null) => {
		if (id) return appStore.fetchAccount(id);

		appStore.resetAccount();

		return null;
	};

	useDidMount(() => reaction(() => appStore.account, v => setAccount(v)));
	useDidMount(() => reaction(() => appStore.isSelectingAccount, v => setIsSelectingAccount(v)));

	return {
		account,
		isSelectingAccount,
		selectAccount,
		accountUrn: appStore.accountUrn,
	};
};

export default useAccount;